import { BehaviorSubject, Observable } from 'rxjs';

export type LoadingStatus = 'idle' | 'loading' | 'success' | 'error';

export interface BaseViewModelState {
  status: LoadingStatus;
  errorMessage?: string | null;
}

export abstract class BaseViewModel<TState extends BaseViewModelState> {
  private readonly stateSubject: BehaviorSubject<TState>;

  protected constructor(initialState: TState) {
    this.stateSubject = new BehaviorSubject<TState>(initialState);
  }

  get vm$(): Observable<TState> {
    return this.stateSubject.asObservable();
  }

  protected patchState(partial: Partial<TState>): void {
    const current = this.stateSubject.value;
    this.stateSubject.next({ ...current, ...partial });
  }

  protected setLoading(message?: string): void {
    this.patchState({ status: 'loading', errorMessage: message ?? null } as Partial<TState>);
  }

  protected setSuccess(): void {
    this.patchState({ status: 'success', errorMessage: null } as Partial<TState>);
  }

  protected setError(message: string): void {
    this.patchState({ status: 'error', errorMessage: message } as Partial<TState>);
  }

  protected get currentState(): TState {
    return this.stateSubject.value;
  }
}
